export const defaultSections = [
  {
    id: 1,
    title: "Personal Details",
    fields: [
      { id: 101, label: "Name", value: "Enter Name" },
      { id: 201, label: "Date Of Birth", value: "Enter Date Of Birth" },
      { id: 301, label: "Complexion", value: "Enter Complexion" },
      { id: 401, label: "Height", value: "Enter Height" },
      { id: 501, label: "Occupation", value: "Enter Occupation" },
      { id: 601, label: "Income", value: "Enter Income" },
      { id: 701, label: "Education", value: "Enter Education" }
    ]
  },
  {
    id: 2,
    title: "Family Details",
    fields: [
      { id: 801, label: "Father's Name", value: "Enter Father's Name" },
      { id: 901, label: "Father's Occupation", value: "Enter Father's Occupation" },
      { id: 1001, label: "Mother's Name", value: "Enter Mother's Name" },
      { id: 1101, label: "Mother's Occupation", value: "Enter Mother's Occupation" }
    ]
  },
  {
    id: 3,
    title: "Contact Details",
    fields: [
      { id: 1201, label: "Name", value: "Enter Name" },
      { id: 1301, label: "Phone Number", value: "Enter Phone Number" },
      { id: 1401, label: "Address", value: "Enter Address" }
    ]
  }
];




